import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { RoutesMap } from '@Router/router.types';
import { routesModel } from '@Router/router.consts';
import { beforeLoadGeneral } from '@Router/middleware';

import { GeneralSpinner } from '@Components/generalSpinner';
import { CddAchVolumes } from '@Pages/happyFlowPages/cddQuestions/pages/cdd-ach-volumes/CddAchVolumes';
import { CddDomesticWireVolumes } from '@Pages/happyFlowPages/cddQuestions/pages/cdd-domestic-wire-volumes/CddDomesticWireVolumes';
import { CddInternationalWiresVolumes } from '@Pages/happyFlowPages/cddQuestions/pages/cdd-international-wires-volumes/CddInternationalWiresVolumes';
import { rootRoute } from './rootRoute';

const CddAchVolumesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.CDD_ACH_VOLUMES].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.CDD_ACH_VOLUMES,
      shouldUpdateServerNavStack: true,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <CddAchVolumes />
    </Suspense>
  ),
});

const CddDomesticWireVolumesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES,
      shouldUpdateServerNavStack: true,
      stepToReturn: RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <CddDomesticWireVolumes />
    </Suspense>
  ),
});

const CddInternationalWiresVolumesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES,
      shouldUpdateServerNavStack: true,
      stepToReturn: RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <CddInternationalWiresVolumes />
    </Suspense>
  ),
});

export const cddRoutes = [
  CddAchVolumesRoute,
  CddDomesticWireVolumesRoute,
  CddInternationalWiresVolumesRoute,
];
